import {IntermediatePart} from "../../intermediatePart";
import Walls from "../../parts/walls";
import {getCurrentRoomType} from "../../../../appLayout";
import {createPageToLoadArray, LOOK_ROOM_TYPES} from "../../constants";
import {navFeatureCLick} from "../../../lookNavigation/lookFunctions";

export default class ShowerWall extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_wall';
    this.partName = 'Shower Wall';
    this.translateId = "visualizer.bathroom.shower.shower_wall";
    this.homePageTitle = 'Interior Shower Walls';
    this.isStoneFeature = true;
    this.canUseWizard = true;
    this.layerPriority = 2;
    if (isChild) {
      createPageToLoadArray(this);
    }
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions();
    const showerParent = this.getParent();
    const showerSize = showerParent ? showerParent.showerSize() : null;
    if (showerSize) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerSize
      })
    }
    // if (wallParent && wallParent.splitWallType) {
    //   conditions.push({
    //     propName: "SplitWallType",
    //     propValue: wallParent.splitWallType
    //   })
    // }
    const wallParent = showerParent.layout.parts[Walls.id];
    if (getCurrentRoomType(showerParent.layout) === LOOK_ROOM_TYPES.as && wallParent && wallParent.splitWall) {
      conditions.push({
        propName: "SplitWallType",
        propValue: wallParent.getSplitWallType()
      })
    }
    return conditions
  }

  /**
   * Keeps the "Full Wall" state when switching between walls:
   * if the current active wall is a full wall - click on the full wall version of the clicked wall,
   * otherwise - regular click (as before)
   * @param ignoreLocked {boolean}
   */
  handleClick(ignoreLocked = false) {
    const featureGroup = this.getParent();
    if (featureGroup && featureGroup.activeFeature && featureGroup.isFullWall() && !featureGroup.isFullWall(this)) {
      const fullWallFeature = this.getSameFeatureFullWall(featureGroup);
      if (fullWallFeature) {
        navFeatureCLick(fullWallFeature, false, ignoreLocked, false); // click on the full wall feature instead
        return;
      }
    }
    super.handleClick(ignoreLocked);
  }

  /**
   * Same wall (by name and conditions) which is a full wall.
   * Same search as in BodyPanelShowerWallFullWallCheckbox.tsx
   * @param featureGroup {ShowerWall}
   * @returns {ShowerWall|undefined}
   */
  getSameFeatureFullWall(featureGroup = this.getParent()) {
    const name1 = this.getSplittedFeatureName();
    const conditions = featureGroup.getArrayOfConditions();
    return featureGroup.features.find(f => {
      return (f.getSplittedFeatureName() === name1) && f.matchesMetaForArrayOfConditions(conditions)
        && (f.dbFeature.id !== this.dbFeature.id)
        && featureGroup.isFullWall(f)
    });
  }

  isFullWall(forFeature = this.activeFeature) {
    // return forFeature?.dbFeature?.metaData?.["Extend"]?.includes("Full")
    return forFeature?.dbFeature?.metaData?.["Extend"]
  }

}
